export default __webpack_public_path__ + "static/media/Path 7.df75ab72.svg";